import moment from 'moment';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from '../../../components/Link';
import { SvgSkipBack } from '../../../icons';
import { ProgramSource, Source } from '../../../queries/ats/titles/types/sources';
import { routes } from '../../../routes/route-utils';
import styles from './details-button.module.scss';

interface WatchFromStartButtonProps {
  source: Source;
}

export const WatchFromStartButton = forwardRef<HTMLAnchorElement, WatchFromStartButtonProps>(({ source }, ref) => {
  const { t } = useTranslation();
  const route = getRoute(source);

  return (
    <Link className={styles.secondary} to={route} ref={ref}>
      <SvgSkipBack className={styles.icon} /> {t('watch from beginning')}
    </Link>
  );
});

function getRoute(source: Source) {
  if (source.type !== 'program') {
    return routes.play({
      platformTitleId: source.platformTitleId,
      providerIdentifier: source.providerIdentifier,
      position: 0,
    });
  }

  const isLive = isLiveProgram(source);
  return isLive
    ? routes.live({ channelId: source.channelId, position: 0 })
    : routes.play({
        platformTitleId: source.platformTitleId,
        providerIdentifier: source.providerIdentifier,
        position: 0,
      });
}

function isLiveProgram(source: ProgramSource) {
  const now = moment();
  return now.isAfter(source.startTime) && now.isBefore(source.endTime);
}
